var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgeBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11531 18.846H12.1153C12.5461 18.846 12.923 18.469 12.923 18.0383V5.38443C12.923 4.46904 11.9538 3.76904 11.1999 3.76904H5.11531C4.68454 3.76904 4.30762 4.14597 4.30762 4.57674V17.2306V18.0383C4.30762 18.469 4.68454 18.846 5.11531 18.846Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4923 6.2461C26.1692 6.1384 25.8462 6.40764 25.8462 6.78456V20.1922C25.8462 20.623 25.4692 20.9999 25.0385 20.9999H2.96154C2.53077 20.9999 2.15385 20.623 2.15385 20.1922V6.8384C2.15385 6.46148 1.72308 6.19225 1.4 6.35379C0.592308 6.73071 0 7.59225 0 8.61533V20.9999C0 22.1846 0.969231 23.1538 2.15385 23.1538H11.0385C11.4692 23.1538 11.8462 23.5307 11.8462 23.9615C11.8462 24.3922 12.2231 24.7692 12.6538 24.7692H15.3462C15.7769 24.7692 16.1538 24.3922 16.1538 23.9615C16.1538 23.5307 16.5308 23.1538 16.9615 23.1538H25.8462C27.0308 23.1538 28 22.1846 28 20.9999V8.61533C28 7.48456 27.6231 6.51533 26.4923 6.2461Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8848 18.846H22.8848C23.3156 18.846 23.6925 18.469 23.6925 18.0383V17.2306V4.57674C23.6925 4.14597 23.3156 3.76904 22.8848 3.76904H16.8002C15.9925 3.76904 15.0771 4.46904 15.0771 5.38443V18.0383C15.0771 18.469 15.4541 18.846 15.8848 18.846Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge_base.9d6b433915bf85725afd8da7dd5b0ca5.svg";
export { ForwardRef as ReactComponent };